/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { makeStyles } from '@mui/styles';
import { neptunePrimary, neptunePrimaryDark, neutral5 } from 'apollo-react/colors';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

import { useTranslation } from '../../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  questionText: {
    margin: '10px 0',
    color: neptunePrimary,
    borderBottom: `1px dotted ${neptunePrimary}`,
    display: 'block',
    width: 'fit-content',
    '&:first-letter': {
      textTransform: 'uppercase',
    },
    '&:hover': {
      color: neptunePrimaryDark,
      cursor: 'pointer',
      borderColor: neptunePrimaryDark,
    },
  },
  searchResult: {
    maxHeight: 250,
    overflowY: 'auto',
  },
  noMatchMessage: {
    color: neutral5,
  },
  emptySearchContainer: {
    height: 40,
    display: 'flex',
    alignItems: 'center',
  },
});

export const SearchPanel = ({ questions, questionValue, handleQuestionChoose }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  if (questions.length === 0) {
    const message = questionValue ? translateString('No match') : '';

    return (
      <div className={classes.emptySearchContainer}>
        <Typography className={classes.noMatchMessage}>{message}</Typography>
      </div>
    );
  }

  return (
    <div className={classes.searchResult}>
      {questions.map(({ question, id }) => (
        <a
          className={classes.questionText}
          key={id}
          onClick={() => handleQuestionChoose(question, id)}
        >
          {question}
        </a>
      ))}
    </div>
  );
};
